import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import AddOpportunity from './AddOpportunity';

const mapStateToProps = state => ({
  merchants: state.merchants,
});

export default withRouter(connect(mapStateToProps, null)(AddOpportunity));
